import React from "react"

import './style.scss'

export default function Banner() {
    return <div className='page-ban'>
        <div className="ban-box">
            <div className="ban-con">
                <div>
                    Workshop on Adversarial Machine<br/>Learning in Real-World Computer Vision<br/>Systems and Online Challenges (AML-CV)
                </div>
                <p>Workshop at CVPR 2021</p>
            </div>
        </div>
    </div>
}

